import { upload } from '../../lib/api.js'
import { toast } from '../../components/feedback/Toast.jsx'

/**
 * Multi-file drop support (Charles, 2026-08-04): every dropped file becomes
 * its own block — images/videos/audio render natively, everything else a
 * document tile. Used by both the editor (drag into an editing session) and
 * the read view (drag onto the page, no editor needed).
 *
 * Uploads run one at a time — kinder to the NAS and to studio wifi than a
 * parallel burst — and a failed file toasts and is skipped, never sinking
 * the rest of the batch.
 */
export async function uploadFilesAsBlocks(pageId, files) {
  const blocks = []
  for (const f of files) {
    try {
      const res = await upload(`/pages/${pageId}/media`, f)
      const kind = ['image', 'video', 'audio'].includes(res.kind) ? res.kind : 'file'
      // blockSchema requires an id on every block — editor blocks carry one.
      blocks.push({ id: crypto.randomUUID(), type: kind, props: { url: res.url, name: f.name } })
    } catch (err) {
      toast(`${f.name}: ${err.message || 'upload failed'}`, 'error')
    }
  }
  return blocks
}

/** The dragged payload's files, or [] when the drag isn't about files. */
export function droppedFiles(e) {
  return [...(e.dataTransfer?.files || [])]
}
